import { Action, configureStore, ThunkDispatch } from "@reduxjs/toolkit";
import { createBrowserHistory } from "history";
import { connectRouter, routerMiddleware, RouterState } from "connected-react-router";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { expertiseReducer, ExpertiseState } from "./expertise/expertise.reducer";
import { reducer as oidcReducer, UserState } from "redux-oidc";
import { authReducer } from "./auth/auth.reducer";
import { AuthState } from "./auth/auth.types";

export const history = createBrowserHistory({
	basename: process.env.NODE_ENV === "production" ? window.config.deployedPath : undefined,
});

export type StoreState = {
	router: RouterState<unknown>;
	expertise: ExpertiseState;
	oidc: UserState;
	auth: AuthState;
};

const createRootReducer = () => ({
	router: connectRouter(history),
	expertise: expertiseReducer,
	oidc: oidcReducer,
	auth: authReducer,
});

export function configureCustomStore() {
	return configureStore({
		reducer: createRootReducer(),
		middleware: (getDefaultMiddleware) => [
			...getDefaultMiddleware({
				serializableCheck: false,
			}),
			routerMiddleware(history),
		],
	});
}

export const store = configureCustomStore();

export default store;

export type AppDispatch = ThunkDispatch<StoreState, any, Action>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<StoreState> = useSelector;
